import {
    DSButton,
    DSDivider,
    DSTableCell,
    DSTableRow,
    DSTypography,
    RelativeTimestamp,
    Timestamp,
} from '@deltasierra/components';
import React from 'react';
import { BlockedPreviewsContentCell } from './BlockedPreviewsContentCell';
import { BlockedTemplateContentBuildEmailPreviewFragment } from './__graphqlTypes/BlockedTemplateContentBuildEmailPreviewFragment';

function Label(props: { label: string }): JSX.Element {
    return <span style={{ fontWeight: 'bold' }}>{`${props.label}: `}</span>;
}
Label.displayName = 'Label';

export type BlockedPreviewsTableRowProps = {
    disableActions: boolean;
    onApprove: (id: string) => void;
    row: BlockedTemplateContentBuildEmailPreviewFragment;
};

export function BlockedPreviewsTableRow({ disableActions, onApprove, row }: BlockedPreviewsTableRowProps): JSX.Element {
    return (
        <DSTableRow>
            <DSTableCell>
                <Timestamp date={row.createdAt} format="long" />
                <br />
                {'('}
                <RelativeTimestamp autoUpdate date={row.createdAt} />
                {')'}
            </DSTableCell>
            <DSTableCell>
                <DSTypography variant="subtitle1">
                    {row?.location?.client?.title ?? 'Could not find client'}
                </DSTypography>
                {row?.location?.title ?? 'Could not find location'}
            </DSTableCell>
            <BlockedPreviewsContentCell row={row} />
            <DSTableCell>
                <Label label="Recipient email" />
                {row.recipientEmail}
                <DSDivider />
                <Label label="Sent by" />
                {row.sentByUsername}
            </DSTableCell>
            <DSTableCell>
                <DSButton color="success" disabled={disableActions} onClick={() => onApprove(row.id)}>
                    {'Approve'}
                </DSButton>
            </DSTableCell>
        </DSTableRow>
    );
}
BlockedPreviewsTableRow.displayName = 'BlockedPreviewsTableRow';
